import { render, staticRenderFns } from "./MFormMpsVueTheMask.vue?vue&type=template&id=681153d0"
import script from "./MFormMpsVueTheMask.vue?vue&type=script&lang=js"
export * from "./MFormMpsVueTheMask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports